export const routerPath = {
  root: '/PersonalTrainers',
};

export const getColumns = ({ editItem, deleteItem }) => [
  {
    id: 'name',
    label: 'Name',
    align: 'left',
    nameForSort: 'name',
  },
  { id: 'surname', label: 'Surname', align: 'center', nameForSort: 'surname' },
  {
    id: 'phoneNumber',
    label: 'Phone Number',
    align: 'center',
    nameForSort: 'phone_number',
  },
  {
    id: 'email',
    label: 'Email',
    align: 'center',
    nameForSort: 'email',
  },
  {
    id: 'more-menu',
    type: 'menu',
    items: [
      { id: 1, name: 'Edit', action: editItem, icon: 'eva:edit-fill' },
      {
        id: 2,
        name: 'Delete',
        action: deleteItem,
        icon: 'eva:trash-2-outline',
        sx: { color: 'error.main' },
      },
    ],
    disableSort: true,
  },
];

export const getFilters = ({ searchByText, facilityId, options }) => [
  {
    id: 'name',
    type: 'search',
    placeholder: 'Search by name, surname, phone, email...',
    action: searchByText.change,
  },
  {
    id: 'facility',
    type: 'select',
    label: 'Facility',
    value: facilityId.value,
    action: facilityId.change,
    items: options?.facilities?.length ? ['all', ...options.facilities] : ['all'],
  },
];
